import { Box } from "@mui/material";
import PaymentsHistory from "../../PaymentsHistory";
import { useProjectPayments } from "../../../../../hooks/api/manageApiHooks";

export default function FinancialTab({
  projectData,
  clearAllFields,
  isDisabled,
  setDisabled,
  initializeLoadingToast,
  updateLoadingToast,
}) {
  const { payments, paymentsLoading } = useProjectPayments(projectData.id);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <PaymentsHistory
        projectId={projectData.id}
        isUniqueCharge={!!projectData.clients.isUniqueCharge}
        clearAllFields={clearAllFields}
        isDisabled={isDisabled}
        setDisabled={setDisabled}
        initializeLoadingToast={initializeLoadingToast}
        updateLoadingToast={updateLoadingToast}
        paymentsHistoryData={payments}
        paymentsHistoryLoading={paymentsLoading}
      />
    </Box>
  );
}
